export default __webpack_public_path__ + "static/media/add-ons.451e4361.svg";